import { queryOptions, useQuery } from '@tanstack/react-query'
import {
  ResponseTypeEnum,
  TraceKey,
  TraceKeyResponseTypeEnum,
  TraceKeysApi,
} from '@ulysses-inc/harami_api_client'
import { useMemo } from 'react'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { queryKeys } from './queryKeys'

const mapResponseTypeToTraceKey: Partial<
  Record<ResponseTypeEnum, TraceKeyResponseTypeEnum>
> = {
  [ResponseTypeEnum.RESPONSE_SET]: TraceKeyResponseTypeEnum.ResponseSet,
  [ResponseTypeEnum.DATETIME]: TraceKeyResponseTypeEnum.Date,
  [ResponseTypeEnum.TEXT]: TraceKeyResponseTypeEnum.Text,
}

const traceKeysQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.lists(),
    queryFn: () => baseClient.getApi(TraceKeysApi).getTraceKeys(),
  })

export const useQueryTraceKeys = () =>
  useQuery({
    ...traceKeysQueryOptions(),
  })

export const useQueryTraceKeysByResponseType = (
  responseType?: ResponseTypeEnum,
) => {
  const selectFn = useMemo(
    () => (traceKeys: TraceKey[]) => {
      if (!responseType) {
        return []
      }
      return traceKeys.filter(
        traceKey =>
          mapResponseTypeToTraceKey[responseType] === traceKey.responseType,
      )
    },
    [responseType],
  )

  return useQuery({
    ...traceKeysQueryOptions(),
    select: selectFn,
  })
}
